export default "__VITE_ASSET__BeqtL_ig__"